export default __webpack_public_path__ + "static/media/04__o_preview_0.450c1f3f.jpg";